import { RECENT_VIEW_KEY } from "./Constants";

export const recentlyViewedProducts = (id) => {

    if (localStorage.getItem(RECENT_VIEW_KEY) === null) {
        let recentView = [];
        recentView.push(id);
        localStorage.setItem(RECENT_VIEW_KEY, JSON.stringify(recentView));
    } else {
        let recentView = JSON.parse(localStorage.getItem(RECENT_VIEW_KEY));
        let tempArr = [];
        if (!recentView.includes(id)) {
            tempArr = [id, ...recentView];
            let newTemp = tempArr.slice(0, 4);
            localStorage.setItem(RECENT_VIEW_KEY, JSON.stringify(newTemp));
        }

    }


}